import { Center, MeshReflectorMaterial, Text3D } from "@react-three/drei";
import { Vector3 } from "@react-three/fiber";
import { Group, Object3DEventMap } from "three";

function FloatingTitle({
  scale,
  position,
  ref
}: {
  scale?: Vector3;
  position?: Vector3;
  ref?: React.Ref<Group<Object3DEventMap>>
}) {
  return (
    <group ref={ref}>
      <Center rotation={[-0.3, 0, 0]} position={position}>
        <Text3D
          scale={scale}
          curveSegments={32}
          bevelEnabled
          bevelSize={0.04}
          bevelThickness={0.1}
          height={0.5}
          lineHeight={0.5}
          letterSpacing={-0.06}
          size={1}
          font="/assets/fonts/Inter_Bold.json"
        >
          {`PEPE3D`}
          <MeshReflectorMaterial
            blur={[300, 30]}
            resolution={2048}
            mixBlur={2}
            mixStrength={180}
            roughness={0.1}
            metalness={0.925}
            minDepthThreshold={0.4}
            maxDepthThreshold={1.4}
            color="#469908"
            mirror={0}
          />
        </Text3D>
      </Center>
    </group>
  );
}

export default FloatingTitle;
